import { emailIsValid } from '@caresend/utils';
import { defineComponent, ref, watch } from 'vue';
import __vue_component__ from './TextInput/TextInput.vue.js';
import { checkEmailAlreadyInUse } from '../../database/firebaseConfig/auth.js';
import '../../database/firebaseConfig/cloudFunctions.js';
import '@caresend/types';
import '@firebase/auth';
import '../../database/firebaseConfig/init.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../database/firebaseConfig/methods.js';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';

// TODO: Replace in-app usages with ui-components version
var script = defineComponent({
    name: 'EmailInput',
    components: { TextInput: __vue_component__ },
    props: {
        autocomplete: {
            type: String,
            default: 'email',
        },
        disabled: Boolean,
        hideIcon: Boolean,
        invalidEmails: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: undefined,
        },
        userCanExist: Boolean,
        userID: {
            type: String,
            default: undefined,
        },
        value: {
            type: String,
            default: undefined,
        },
    },
    emits: {
        enter: () => true,
        input: (_value) => true,
        setIsEmailValid: (_isValid) => true,
    },
    setup(props, { emit }) {
        const isValid = ref(false);
        const isLoading = ref(false);
        const message = ref('This email is invalid');
        const checkEmailAllowed = async () => {
            var _a, _b;
            isLoading.value = true;
            const locallyInUse = props.invalidEmails.includes((_a = props.value) !== null && _a !== void 0 ? _a : '');
            if (props.userCanExist) {
                isValid.value = !locallyInUse;
            }
            else {
                try {
                    const { email, isInUse } = await checkEmailAlreadyInUse({
                        email: (_b = props.value) !== null && _b !== void 0 ? _b : '',
                        checkingUserID: props.userID,
                    });
                    if (props.value === email)
                        isValid.value = !isInUse && !locallyInUse;
                }
                catch (error) {
                    isValid.value = false;
                }
            }
            message.value = isValid.value ? 'This email is valid' : 'This email is already in use';
            emit('setIsEmailValid', isValid.value);
            isLoading.value = false;
        };
        watch(() => props.value, (email) => {
            if (props.disabled) {
                isValid.value = true;
                message.value = 'This email is valid';
                emit('setIsEmailValid', true);
            }
            else if (email && emailIsValid(email)) {
                checkEmailAllowed();
            }
            else {
                message.value = 'This email is invalid';
                isValid.value = false;
                emit('setIsEmailValid', false);
            }
        }, { immediate: true });
        return {
            isLoading,
            isValid,
            message,
        };
    },
});

export { script as default };
